import useEventQueue from "@/features/hotkeys/hooks/use-event-queue.ts";
import useToggleLogger from "@/features/hotkeys/hooks/use-toggle-logger.ts";

export default function RegisterHotkeys() {
    useToggleLogger();
    useEventQueue();

    return null;
}
